export const CART_ACTIONS = {
  ADD_CART_ITEM: 'ADD_CART_ITEM',
  SET_CART_ITEMS: 'SET_CART_ITEMS',
  UPDATE_CART_ITEMS: 'UPDATE_CART_ITEMS',
  DELETE_CART_ITEM: 'DELETE_CART_ITEM',
  UPDATE_CART_ITEM: 'UPDATE_CART_ITEM',
  CLEAR_CART: 'CLEAR_CART',
  UPDATE_CART_ITEM_INVENTORY: 'UPDATE_CART_ITEM_INVENTORY'
}
